import type { InjectionKey } from 'vue'

// The app header's `#page-title` slot. A layout that renders the host PROVIDES
// this key; PageTitle teleports into the host only when it is provided, and
// renders in place otherwise (specs mounting a view alone, a shell without the
// host). Provided, not looked up with `document.getElementById`: on the first
// paint the shell's header is built OFF-document (Vue inserts a parent after its
// children), so a lookup at setup would miss a host that is about to exist.
export const PAGE_TITLE_HOST: InjectionKey<boolean> = Symbol('page-title-host')

export const PAGE_TITLE_HOST_ID = 'page-title'
